(function () {
  var base = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  function init(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    var items = root.querySelectorAll('.ph-reveal');
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      items.forEach(function (el) { el.classList.add('is-in'); });
    }
    var toast = root.querySelector('[data-ph-toast]');
    var timer;
    function showToast(html) {
      if (!toast) return;
      toast.innerHTML = html;
      toast.classList.remove('is-on'); void toast.offsetWidth; toast.classList.add('is-on');
      clearTimeout(timer); timer = setTimeout(function () { toast.classList.remove('is-on'); }, 2700);
    }
    root.querySelectorAll('[data-ph-card]').forEach(function (card) {
      var variants = [];
      try { variants = JSON.parse(card.querySelector('[data-ph-variants]').textContent); } catch (e) {}
      var buy = card.querySelector('[data-ph-buy]');
      var group = card.querySelector('[data-ph-size-index]');
      if (!buy) return;
      var label = buy.querySelector('.ph-buy__label');
      if (group) {
        var idx = parseInt(group.dataset.phSizeIndex, 10);
        group.querySelectorAll('[data-ph-size]').forEach(function (btn) {
          var val = btn.dataset.phSize;
          var ok = variants.some(function (v) { return v.a && v.o[idx] === val; });
          if (!ok) btn.disabled = true;
          btn.addEventListener('click', function () {
            group.querySelectorAll('[data-ph-size]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
            btn.setAttribute('aria-pressed', 'true');
            var m = variants.filter(function (v) { return v.a && v.o[idx] === val; })[0];
            if (m) buy.dataset.variant = m.id;
          });
        });
      }
      buy.addEventListener('click', function () {
        if (buy.disabled) return;
        buy.classList.add('is-loading');
        fetch(base + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(buy.dataset.variant, 10), quantity: 1 }] })
        })
        .then(function (r) { if (!r.ok) throw r; return r.json(); })
        .then(function () { return fetch(base + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (cart) {
          buy.classList.remove('is-loading');
          buy.classList.add('is-done');
          label.textContent = 'Añadido ✓';
          setTimeout(function () { buy.classList.remove('is-done'); label.textContent = 'Añadir al carrito'; }, 2200);
          showToast('Añadido al carrito · <a href="' + base + 'cart">Ver carrito (' + cart.item_count + ')</a>');
          document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'ph-home', data: { itemCount: cart.item_count, source: 'ph-home' } } }));
          document.querySelectorAll('[data-cart-count], .cart-count, .cart-bubble__text-count').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {
          buy.classList.remove('is-loading');
          showToast('No se pudo añadir. Elige opciones en la ficha del producto.');
        });
      });
    });
  }
  function boot() { document.querySelectorAll('.ph-root').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();